import React from 'react';
import type { AssetStyleId } from 'fym-shared/src/music24/assetStyles';
import type { StudioThemeId } from 'fym-shared/src/music24/studioThemes';
import { isLyricSampleStyle } from 'fym-shared/src/music24/releaseKitLookSamples';
import { TypedMemo } from '../../../../../common/types';
import { ThemeStill } from '../../../themes/ThemeStill';
import { LyricCardSample } from '../../../themes/LyricCardSample';
import type { ThemeStillLayout } from '../../../themes/themeStillVars';
import type { StoryPreviewContext } from './storyPreviewContext';
import type { ImageStyleSong } from './ImageStyleTiles';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the image tiles; each part uses its own slice of it */
import styles from './ImageTiles.module.scss';
/* eslint-enable css-modules/no-unused-class */

const LAYOUTS: Partial<Record<AssetStyleId, ThemeStillLayout>> = {
  coverCard: 'card',
  coverGround: 'ground',
  typeOnly: 'type',
};

interface ImagePreviewProps {
  assetTypeId: StudioThemeId;
  style: AssetStyleId | null;
  context: StoryPreviewContext;
  song: ImageStyleSong;
}

/**
 * The rail preview of an image that is not a Story: the lyric card sample of the theme, else the
 * theme still in the picked style. A Story and a feed post have the real layout (`StoryPreview`).
 */
const ImagePreviewComponent: React.FC<ImagePreviewProps> = ({ assetTypeId, style, context, song }) => {
  if (assetTypeId === 'lyricCard' && style !== null && isLyricSampleStyle(style)) {
    return (
      <div className={styles.railStill}>
        <LyricCardSample themeId={context.look.themeId} style={style} />
      </div>
    );
  }
  return (
    <div className={styles.railStill}>
      <ThemeStill
        themeId={context.look.themeId}
        fontOverride={context.look.fontOverride}
        palette={context.palette}
        artworkUrl={song.artworkUrl}
        title={song.title}
        artist={song.artist}
        kicker={song.kicker}
        layout={style === null ? 'card' : (LAYOUTS[style] ?? 'card')}
        tall={assetTypeId === 'countdown'}
      />
    </div>
  );
};

export const ImagePreview = TypedMemo(ImagePreviewComponent);
